import { reduce, get, sortBy } from 'lodash';
import { normalizeEvFeature } from '../resources/normalizeHelpers/normalizeHelpers.constant';

const normalizeDisclaimers = (disclaimers) =>
  reduce(
    disclaimers,
    (hash, disclosure) => {
      hash[disclosure.ss] = disclosure.label;
      return hash;
    },
    {}
  );

const createNormalizeDisclosures = (evFeatures) => {
  const {
    featuresFormatted,
    featureDisclaimers,
    addFeaturesFormatted,
    addFeatureDisclaimers,
  } = evFeatures;

  const normalizedFeatureDisclaimers = normalizeDisclaimers(featureDisclaimers);
  const normalizedMoreFeatureDisclaimers = normalizeDisclaimers(
    addFeatureDisclaimers
  );
  return {
    featuresFormatted: normalizeEvFeature(
      featuresFormatted,
      normalizedFeatureDisclaimers
    ),
    featureDisclaimers: normalizedFeatureDisclaimers,
    addFeatureDisclaimers: normalizedMoreFeatureDisclaimers,
    addFeaturesFormatted: normalizeEvFeature(
      addFeaturesFormatted,
      normalizedMoreFeatureDisclaimers
    ),
  };
};

const normalizeMatrix = (matrix) => {
  for (let option of matrix.options) {
    const msrpData = option.msrp;
    option.styleId = `${option.styleId}`;
    option.rearWheelType = `${option.rearWheelType || ''}`;
    const bodyType = option.bodyType || option.bodyTypeId || '';
    option.bodyType = bodyType;
    delete option.bodyTypeId;
    option.msrp = get(msrpData, 'amount.value', 0);
    option.message = get(msrpData, 'unknown') || '';
  }
  matrix.options = sortBy(matrix.options, 'msrp');

  const { bodyTypes } = matrix;

  const normalizeDriveTypeDetail = (driveType) => {
    const { dtd } = driveType;

    if (!dtd) {
      return driveType;
    }

    const { specsFormatted, specDisclaimers } = dtd;
    const normalizedSpecDisclaimers = normalizeDisclaimers(specDisclaimers);
    return {
      ...driveType,
      dtd: {
        ...dtd,
        specDisclaimers: normalizedSpecDisclaimers,
        specsFormatted: normalizeEvFeature(
          specsFormatted,
          normalizedSpecDisclaimers
        ),
      },
    };
  };

  return {
    ...matrix,
    bodyTypes: bodyTypes.map((x) => {
      return {
        ...x,
        rearWheelType: x.rearWheelType || '',
        evFeatures: x.evFeatures && {
          ...x.evFeatures,
          ...createNormalizeDisclosures(x.evFeatures),
        },
        driveTypes: x.driveTypes.map((driveType) => {
          return normalizeDriveTypeDetail(driveType);
        }),
      };
    }),
  };
};

export const fetchTrimMatrixWithState = (state, optionalParams = {}) => {
  const { api, params } = state;
  const { v3ServicesPath } = api;
  const combinedParams = { ...params, ...optionalParams };
  const {
    bodystyle,
    brand,
    carline,
    country,
    lang,
    modelyear,
    postalCode,
  } = combinedParams;
  const matrixUrl = `${v3ServicesPath}/trim-matrix/${lang}/${country}/${brand}/${carline}/${modelyear}/${bodystyle}?postalCode=${postalCode}`;

  return fetch(matrixUrl)
    .then((res) => res.json())
    .then(normalizeMatrix);
};

export const fetchTrimMatrixWithModelInfo = (modelInfo, postalCode) => {
  const { modelPath, v3ServicesPath } = modelInfo;
  const matrixUrl = `${v3ServicesPath}/trim-matrix/${modelPath}?postalCode=${postalCode}`;

  return fetch(matrixUrl)
    .then((res) => res.json())
    .then(normalizeMatrix);
};
